import React, {useState} from 'react';

import { useDispatch } from 'react-redux';

import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';

import {
  Tooltip,
} from '@material-ui/core';


import Swal from 'sweetalert2';

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';
import { SidebarMenu } from '../shared/SidebarMenu';

import { sesionExpired } from '../../constants/auth/sesionExpired';
import { timeSessionDifference } from '../../constants/auth/timeSessionDifference';
import { actionErrorConnection } from "../../constants/component/actionErrorConnection";



import '../../styles/style.scss';
import '../../styles/createContentStyle.scss';
import termsAndConditionsService from '../../services/termsAndConditions.service';
import { getReturnPage, handleCancel } from '../utils/handleFunctions';

export const CreateTermsAndConditionsScreen = (props) => {


  const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
  const sessionDifference = timeSessionDifference();

  const dispatch = useDispatch();
  const history = useHistory();

  const [isDisabled, setDisabled] = useState(true);
  const [ file, setFile ] = useState(null);


  const [isLoadingForm, setIsLoadingForm] = useState(false);
//   const fileToBase64 = (fileData, cb) => {

//     if (!fileData){
//       return;
//     }
//     const reader = new FileReader();
//     reader.readAsDataURL(fileData)
//     reader.onload = function () {
//       cb(null, reader.result)
//     }
//     reader.onerror = function (error) {
//       cb(error, null)
//     }
//   }

  /**
   * Si el archivo se subió, regresa a la página anterior
   * @param {*} result - respuesta de la solicitud
   * @author KenzoSashida
   * @version 1.0.0 - Julio 2024
   */
  

  
  /**
   * Recupera el archivo cargado
   * @param {*} target - recupera la información del imput de carga de archivo 
   * @returns 
   * @author Kenzo Sashida
   * @version 1.0.0 - Julio 2024
   */
  const onUploadFileChange = ({ target }) => {
    if (target.files < 1 || !target.validity.valid || target.files[0].size > 10485760 || target.files[0].type !== "application/pdf") {
      alert("El archivo no es válido")
      return
    }
    const originalFile = target.files[0]
    const originalFileName = originalFile.name
    console.log("namee", originalFileName)
    const renamedFile = new File([originalFile], originalFileName,{
        type: originalFile.type,
    })
    setFile(renamedFile)    
    setDisabled(false);
  }
  /**
   * Envia la información del formulario para crear un nuevo archivo de términos y condiciones
   * @author Kenzo Sashida
   * @version 1.0.0 - Julio 2024
   */
  const onSubmit = async(e) => {
      e.preventDefault()
      setIsLoadingForm(true);
      try{
        const response = await termsAndConditionsService.uploadFileTermsAndConditions(file)
        setIsLoadingForm(false)
        Swal.fire({
            icon: 'success',
            title: response.message,
            showConfirmButton: true,
            confirmButtonText: 'Regresar'
          }).then((result)=>{
            getReturnPage(result, '/administration/terms-and-conditions', props.history)
          })
    }catch(error){
        setIsLoadingForm(false)
        if(sessionDifference> Number(tokenExpired)){
            sesionExpired(dispatch, history)
        }else{
            console.log(error)
            actionErrorConnection(error, "Error al cargar archivo")
        }}
  };

 
  return (
    <>
      <div className="container-fluid p-0 m-0">
        <div className="row flex-nowrap p-0 m-0">
          <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
            <SidebarMenu />
          </div>
          <div className="col p-0 ms-1 me-1">
            <NavTopMenu />
            <div className="container ps-3 pe-3 container-size">
              <div className="row base-container ">
                <div className="col-12 border-title text-title pt-2 pb-2 ps-4 h4">
                  <div className="row">
                    <div className="col-10 text-title">
                      <span>Subir Nuevos T&eacute;rminos y Condiciones</span>
                    </div>
                    <div className="col-2 text-title">
                      <div className="w-100 d-flex justify-content-end">
                        <Tooltip title="Regresar" placement="top-start" arrow>
                          <button className="btn custom-btn-icons" 
                            type="button" 
                            onClick={() => handleCancel('return', '/administration/terms-and-conditions', props.history)}>
                            <i className="fas fa-angle-left custom-icon-return"></i>
                          </button>
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                </div>   
                <div className="col-12 pt-3 pb-3 ps-4 pe-4">
                  <form onSubmit={onSubmit}>
                    <div className="container p-0">
                      <div className="row ">
                        <div className="col-md-3">
                          <div className="border-text-menu-title">
                            <span className="text-subtitle">Cargar archivo</span>
                          </div>
                        </div>
                        <div className="col-md-9 pt-5">
                          <div className="row">
                            <div className="col-md-12 mt-2 mb-2 input-group">
                              <input 
                                type="file" 
                                name="file" 
                                id="file"
                                className="form-control" 
                                accept="application/pdf"
                                onChange={onUploadFileChange} 
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex flex-row-reverse ">
                        <div className="col-md-9 d-flex flex-row-reverse border-button-actions mt-2 pt-2">
                          <button  
                            className="btn custom-btn pt-2 pb-2 ps-3 pe-3" 
                            type="submit"
                            disabled={isDisabled || isLoadingForm}>
                            <span className="me-2">Agregar</span>
                            {
                              isLoadingForm
                              ? <i className="fas fa-spinner fa-spin"></i>
                              : <i className="fas fa-save"></i>
                            } 
                          </button>
                          <button  
                            className="btn custom-cancel-btn pt-2 pb-2 ps-3 pe-3 me-3"
                            type="button" 
                            onClick={() => handleCancel('cancel', '/administration/terms-and-conditions', props.history)}>
                            Cancelar
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

CreateTermsAndConditionsScreen.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    })
  }),
  history: PropTypes.object
}
